<template>
    <b-container class="p-0">
        <!-- FORMULAIRE PARTICULIER -->
        <ParticularForm :CustomerInfo.sync="customerInfo" :PhoneConfig="PhoneConfig" :Variant="Variant"/>
        <b-card no-body>
            <!-- INFORMATIONS ENTREPRISE -->
            <b-form-group
                :label="$t('CompanyInformations') + ' :'"
                label-cols="1"
                label-cols-lg="12"
                label-class="font-weight-bold text-dark pt-0 pb-2"
                label-align-sm="left"
                label-size="lg"
                class="bg-white rounded p-2">
                <!-- NOM ENTREPRISE -->
                <ValidationProvider rules="required" :name="$t('CompanyName')" v-slot="{ errors, valid }"  tag="div">
                    <b-form-group
                        :label="$t('CompanyName') + ' *'"
                        label-for="Input_CompanyName"
                        :label-cols-sm="4"
                        label-align-sm="left"
                        class="mb-1">
                        <b-form-input
                            id="Input_CompanyName"
                            v-model="customerInfo.CompanyName"
                            type="text"
                            :state="errors.length > 0 ? false : (valid ? true : false)"/>
                        <span class="text-danger">{{ errors[0] }}</span>
                    </b-form-group>
                </ValidationProvider>
                <!-- TYPE D'ENTREPRISE -->
                <ValidationProvider rules="required" :name="$t('Type')" v-slot="{ errors, valid }" tag="div">
                    <b-form-group
                        :label="$t('Type') + ' *'"
                        label-for="Input_LegalStatus"
                        :label-cols-sm="4"
                        label-align-sm="left"
                        class="mb-1 d-flex align-items-center" >
                        <b-form-radio-group
                            v-model="customerInfo.ProfessionalType"
                            :options="CompanyTypeOptions"
                            :state="errors.length > 0 ? false : (valid ? true : false)"/>
                        <span class="text-danger">{{ errors[0] }}</span>
                    </b-form-group>
                </ValidationProvider>
                <!-- SIRET ENTREPRISE -->
                <ValidationProvider rules="required|Siret" :name="$t('Siret')" v-slot="{ errors, valid }" tag="div">
                    <b-form-group
                        :label="$t('SIRET') + ' *'"
                        label-for="Input_Siret"
                        :label-cols-sm="4"
                        label-align-sm="left"
                        class="mb-1">
                        <b-form-input
                            id="Input_Siret"
                            v-model="customerInfo.Siret"
                            type="text"
                            v-mask="'##############'"  
                            placeholder="12345678901234"
                            :state="errors.length > 0 ? false : (valid ? true : false)"/>
                        <span class="text-danger">{{ errors[0] }}</span>
                    </b-form-group>
                </ValidationProvider>
                <!-- ADRESSE ENTREPRISE -->
                <ValidationProvider rules="required" :name="$t('Address')" v-slot="{ errors, valid }" tag="div">
                    <b-form-group
                        :label="$t('Address') + ' *'"
                        label-for="Input_Address"
                        :label-cols-sm="4"
                        label-align-sm="left"
                        class="mb-1">
                        <b-form-input
                            id="Input_Address"
                            v-model="customerInfo.Address"
                            type="text"
                            :state="errors.length > 0 ? false : (valid ? true : false)"/>
                        <span class="text-danger">{{ errors[0] }}</span>
                    </b-form-group>
                </ValidationProvider>
                <!-- CODE POSTAL ENTREPRISE -->
                <ValidationProvider rules="required|Zipcode" :name="$t('Zipcode')" v-slot="{ errors, valid }" tag="div">
                    <b-form-group
                        :label="$t('Zipcode') + ' *'"
                        label-for="Input_Zipcode"
                        :label-cols-sm="4"
                        label-align-sm="left"
                        class="mb-1">
                        <b-form-input
                            id="Input_Zipcode"
                            v-model="customerInfo.Zipcode"
                            type="text"
                            v-mask="'#####'"
                            placeholder="86000"
                            :state="errors.length > 0 ? false : (valid ? true : false)"/>
                        <span class="text-danger">{{ errors[0] }}</span>
                    </b-form-group>
                </ValidationProvider>
                <!-- VILLE ENTREPRISE -->
                <ValidationProvider rules="required" :name="$t('City')" v-slot="{ errors, valid }" tag="div">
                    <b-form-group
                        :label="$t('City') + ' *'"
                        label-for="Input_City"
                        :label-cols-sm="4"
                        label-align-sm="left"
                        class="mb-1">
                        <b-form-input
                            id="Input_City"
                            v-model="customerInfo.City"
                            type="text"
                            :state="errors.length > 0 ? false : (valid ? true : false)"/>
                        <span class="text-danger">{{ errors[0] }}</span>
                    </b-form-group>
                </ValidationProvider>
                <!-- FONCTION CLIENT -->
                <ValidationProvider rules="NoSpecialChar" :name="$t('Function')" v-slot="{ errors, valid, dirty }" tag="div">
                    <b-form-group
                        :label="$t('Function')"
                        label-for="Input_Function"
                        :label-cols-sm="4"
                        abel-align-sm="left"
                        class="mb-1">
                        <b-form-input
                            id="Input_Function"
                            v-model="customerInfo.Function" 
                            type="text"
                            :state="errors.length > 0 ? false : (valid ? true : false)"/>
                        <span class="text-danger">{{ errors[0] }}</span>
                    </b-form-group>
                </ValidationProvider>
            </b-form-group>
        </b-card>
    </b-container>
</template>
<script lang="ts">

    /**
     * Composants Vue js
     */
    import { Vue, Component, PropSync, InjectReactive, Prop } from 'vue-property-decorator';

    /**
     * Composant formulaire particulier
     */
    import ParticularForm from './ParticularForm.vue';

    /**
     * Validation formulaire
     */
    import { ValidationProvider } from 'vee-validate';
    import '@/vee-rules';

    /**
     * Classes
     */
    import { ProfessionalCustomerInformation } from '@/types/Administration/SMA/CustomerInfo';
    import { PhoneConfig } from '@/types/Administration/SMA/SMADistributorForm';

    /**
     * Traductions
     */
    import locale from '../../../locales/SMA.json';
    
	@Component({
		components: {
            ParticularForm,
            ValidationProvider
        },
        i18n:{messages:locale}
	})
    /**
     * Formulaire distributeur pour les professionnels
     */
	export default class ProfessionalForm extends Vue {
    
        /**
         * Informations client
         */
        @PropSync('CustomerInfo', { default: () => {} })
        public customerInfo!: ProfessionalCustomerInformation;
        
        /** 
         * Variant de couleur à appliquer sur le composant 
         */
        @InjectReactive()
        public Variant!: string;

        /**
         * Configuration de validation du téléphone
         */
        @Prop()
        public PhoneConfig!: PhoneConfig;
        
        /** Options de type de professionnel */
        protected CompanyTypeOptions: { [key: number]: string } = {
            0 : "Autre",
            1 : "Entreprise",
            2 : "Collectivité",
            3 : "EPCI",
            4 : "Association",
        }
}
    
</script>
<style scoped>
</style>